import { BiCompass } from 'react-icons/bi';

export const conhecerOErp = {
  id: 'conhecer-o-erp',
  titulo: 'Conhecer o ERP',
  descricao: 'O menu lateral, os conceitos de cliente e anexo e o tema claro ou escuro.',
  icone: BiCompass,
  passos: [
    {
      alvo: 'menu:Dashboard',
      titulo: 'Menu lateral',
      texto:
        'Cada item abre uma área do ERP. O que aparece aqui depende do seu nível de acesso, definido pelo gestor em Usuarios.',
      lado: 'right',
    },
    {
      alvo: 'menu:Clientes',
      titulo: 'Clientes',
      texto:
        'Prefeituras, câmaras e empresas. O estoque da Vox fica num cliente também: VOXCITY TECNOLOGIA.',
      fala: 'Prefeituras, câmaras e empresas. O estoque da Vox fica num cliente também: Vox City Tecnologia.',
      lado: 'right',
    },
    {
      alvo: 'menu:Anexos',
      titulo: 'Anexos',
      texto:
        'O anexo é o local ou o contrato dentro do cliente, como a SEDE VOX. Todo patrimônio está num cliente e num anexo.',
      fala: 'O anexo é o local ou o contrato dentro do cliente, como a Sede Vox. Todo patrimônio está num cliente e num anexo.',
      lado: 'right',
    },
    {
      alvo: 'menu:Patrimônio',
      titulo: 'Patrimônio',
      texto:
        'Cada equipamento com etiqueta. É aqui que se consulta, cadastra, separa e movimenta, do recebimento até o envio ao cliente.',
      lado: 'right',
    },
    {
      alvo: 'menu:Entrada',
      titulo: 'Entrada',
      texto: 'Toda compra entra no estoque por aqui, de preferência pelo XML da nota fiscal.',
      lado: 'right',
      // O menu Entrada é só do nível Admin: para os outros o passo sai do tutorial.
      exigeAdmin: true,
    },
    {
      alvo: 'menu:Relatórios',
      titulo: 'Relatórios',
      texto: 'Patrimônio por cliente e Status da instalação: são os relatórios da auditoria mensal.',
      lado: 'right',
    },
    {
      alvo: 'menu:alternar',
      titulo: 'Recolher o menu',
      texto: 'Recolhe o menu e deixa só os ícones, para sobrar espaço na tela. Clique de novo para abrir.',
      lado: 'right',
    },
    {
      alvo: 'tema',
      titulo: 'Tema claro ou escuro',
      texto: 'Alterna entre o tema claro e o escuro. O ERP lembra a sua escolha.',
      lado: 'bottom',
    },
    {
      alvo: 'menu:Tutoriais',
      titulo: 'Tutoriais',
      texto: 'Os tutoriais ficam aqui. Dá para refazer qualquer um quando quiser.',
      lado: 'right',
    },
  ],
};
